var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"w-loader",attrs:{"align-center":"","justify-center":"","fill-height":"","text-xs-center":""}},[_c('v-flex',[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"accent"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }